<template>
  <div class="cards">
    <a-menu
      class="card-menu"
      id="dddddd"
      v-model:openKeys="openKeys"
      v-model:selectedKeys="selectedKeys"
      placeholder="Seleccionar identificador"
      style="width: 256px"
      mode="inline"
      :items="items"
      @click="handleClick"
    >
    </a-menu>
    <a-card class="card-template">
      <WhatsappTemplatesTemplate v-if="selectedKeys[0] == '1'" />
      <SmsTemplatesTemplate v-else-if="selectedKeys[0] == '2'" />
      <div v-else>
        <div class="not-content">
          <svg
            width="63"
            height="63"
            viewBox="0 0 63 63"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M22.05 8.53125H21.9634C19.0965 8.53123 16.8246 8.53122 14.9933 8.68084C13.1207 8.83384 11.5361 9.15306 10.0893 9.89026C7.74316 11.0857 5.83568 12.9932 4.64026 15.3393C3.90306 16.7861 3.58384 18.3707 3.43084 20.2433C3.28122 22.0746 3.28123 24.3465 3.28125 27.2134V27.3V35.7V35.7866C3.28123 38.6535 3.28122 40.9254 3.43084 42.7567C3.58384 44.6293 3.90306 46.2139 4.64026 47.6607C5.83568 50.0068 7.74316 51.9143 10.0893 53.1097C11.5361 53.8469 13.1207 54.1662 14.9933 54.3192C16.8246 54.4688 19.0965 54.4688 21.9635 54.4688H22.05H40.95H41.0365C43.9035 54.4688 46.1754 54.4688 48.0067 54.3192C49.8793 54.1662 51.4639 53.8469 52.9107 53.1097C55.2568 51.9143 57.1643 50.0068 58.3597 47.6607C59.0969 46.2139 59.4162 44.6293 59.5692 42.7567C59.7188 40.9254 59.7188 38.6535 59.7188 35.7865V35.7V27.3V27.2135C59.7188 24.3465 59.7188 22.0746 59.5692 20.2433C59.4162 18.3707 59.0969 16.7861 58.3597 15.3393C57.1643 12.9932 55.2568 11.0857 52.9107 9.89026C51.4639 9.15306 49.8793 8.83384 48.0067 8.68084C46.1754 8.53122 43.9035 8.53123 41.0366 8.53125H40.95H22.05ZM11.8769 13.3986C12.6761 12.9914 13.6848 12.7384 15.3139 12.6053C16.9661 12.4703 19.0772 12.4688 22.05 12.4688H40.95C43.9228 12.4688 46.0339 12.4703 47.6861 12.6053C49.3152 12.7384 50.3239 12.9914 51.1231 13.3986C52.7284 14.2165 54.0335 15.5216 54.8514 17.1269C55.2586 17.9261 55.5116 18.9348 55.6447 20.5639C55.7797 22.2161 55.7812 24.3272 55.7812 27.3V35.7C55.7812 38.6728 55.7797 40.7839 55.6447 42.4361C55.5116 44.0652 55.2586 45.0739 54.8514 45.8731C54.0335 47.4784 52.7284 48.7835 51.1231 49.6014C50.3239 50.0086 49.3152 50.2616 47.6861 50.3947C46.0339 50.5297 43.9228 50.5312 40.95 50.5312H22.05C19.0772 50.5312 16.9661 50.5297 15.3139 50.3947C13.6848 50.2616 12.6761 50.0086 11.8769 49.6014C10.2716 48.7835 8.96652 47.4784 8.1486 45.8731C7.74137 45.0739 7.48837 44.0652 7.35527 42.4361C7.22028 40.7839 7.21875 38.6728 7.21875 35.7V27.3C7.21875 24.3272 7.22028 22.2161 7.35527 20.5639C7.48837 18.9348 7.74137 17.9261 8.1486 17.1269C8.96652 15.5216 10.2716 14.2165 11.8769 13.3986ZM16.8421 19.3619C15.9374 18.7588 14.715 19.0032 14.1119 19.9079C13.5088 20.8126 13.7532 22.035 14.6579 22.6381L30.4079 33.1381C31.0692 33.579 31.9308 33.579 32.5921 33.1381L48.3421 22.6381C49.2468 22.035 49.4912 20.8126 48.8881 19.9079C48.285 19.0032 47.0626 18.7588 46.1579 19.3619L31.5 29.1339L16.8421 19.3619Z"
              fill="black"
              fill-opacity="0.45"
            />
          </svg>

          <span
            >Contamos con un módulo especializado para plantillas de correos.
            <router-link to="/email/templates-email">Click aquí</router-link> para ir al
            módulo.</span
          >
        </div>
      </div>
    </a-card>
  </div>
</template>
<script lang="ts" setup>
import { reactive, ref, watch, VueElement, h, VNode } from "vue";
import { MailOutlined, WhatsAppOutlined, MessageOutlined } from "@ant-design/icons-vue";
import type { MenuProps } from "ant-design-vue";
import SmsTemplatesTemplate from "@/app/channels/components/templates/SmsTemplatesTemplate.vue";
import WhatsappTemplatesTemplate from "@/app/channels/components/templates/WhatsappTemplatesTemplate.vue";
const selectedKeys = ref<string[]>(["1"]);
const openKeys = ref<string[]>(["sub1"]);

interface ItemType {
  key: string;
  icon?: any;
  children?: ItemType[];
  label: VNode | string;
  type?: "group";
}

function getItem(
  label: VueElement | string,
  key: string,
  icon?: () => VNode,
  children?: ItemType[],
  type?: "group"
): ItemType {
  return {
    key,
    icon: undefined,
    children,
    label: h("span", { class: "menu-item-content" }, [
      h("span", { class: "menu-label" }, label),
      icon ? h(icon, { class: "icon-right" }) : null,
    ]),
    type,
  } as ItemType;
}

const items: ItemType[] = reactive([
  getItem("WhatsApp ", "1", () => h(WhatsAppOutlined)),
  getItem("SMS ", "2", () => h(MessageOutlined)),
  getItem("Correo Electrónico ", "3", () => h(MailOutlined)),
]);

const handleClick: MenuProps["onClick"] = (e) => {
  console.log("click", e);
};

watch(openKeys, (val) => {
  console.log("openKeys", val);
});
</script>
<style lang="sass" scoped>
.menu-item-content
  display: flex
  align-items: center
  justify-content: space-between

.menu-label
  margin-right: 8px

.icon-right
  margin-left: 8px

.cards
  display: flex
  margin-top: 10px
  .card-menu
    width: 300px
    height: calc(100vh - 80px)
    border: 1px solid $gray-5
    padding: 0 !important
    padding-top: 20px !important
    border-radius: 0 8px 0 0

  .card-template
    width: calc(100% - 300px)
    margin-left: 10px
    border: 1px solid $gray-5
    border-radius: 8px
    :deep(.ant-card-body)
      padding: 0 !important

.not-content
  height: calc(100vh - 350px)
  display: flex
  align-items: center
  justify-content: center
  flex-direction: column
  span
    font-size: 20px
    width: 410px
    text-align: center
    margin-bottom: 20px
    weight: 400
    color: $gray-7

:deep(.ant-menu-item-selected)
  border-radius: 0
  border-right: 3px solid #1677FF

:deep(.ant-menu-item)
  margin: 0
  width: 100%
</style>
